
import blueprintReducer from './blueprints';

const EMPTY_MODULE = {
  Name: 'My adventure',
  ID: 'my_mod',
  Icon: 88,
  OnInit: '',
  OnLoad: '',
  OnSave: '',
  Inclues: [],
  Blueprints: []
};


const ACTION_NEW = 'module.new';
const ACTION_UPDATE = 'module.update';

export function updateModule(props) {
  return {
    type: ACTION_UPDATE,
    payload: {
      ...props
    }
  };
}

export function newModule() {
  return {
    type: ACTION_NEW,
    payload: {}
  };
}

const reducer = function(state = EMPTY_MODULE, action) {
  switch (action.type) {
    case ACTION_NEW:
      return EMPTY_MODULE;

    case ACTION_UPDATE:
      return {...state, ...action.payload};

    default: {
      const bp = blueprintReducer(state.Blueprints, action);
      return {...state, Blueprints: bp };
    }
  }
}

export default reducer;
